import { LayoutDashboard, Plus } from "lucide-react";
import { EmptyState } from "../ui";

export default function NoDashboardsState({ onNew }: { onNew: () => void }) {
  return (
    <EmptyState
      className="h-full"
      icon={<LayoutDashboard size={40} />}
      title="No dashboards yet"
      description="Create your first dashboard and Brian will generate tiles based on what you want to track."
      action={
        <button
          onClick={onNew}
          className="flex items-center gap-2 rounded-lg bg-[#1D345F] px-4 py-2 text-sm font-medium text-white hover:bg-[#162847]"
        >
          <Plus size={14} />
          Create dashboard
        </button>
      }
    />
  );
}
